import { es } from './es';
import { en } from './en';
import { pt } from './pt';

export const translations = {
  es,
  en,
  pt
};

// Helper function to get nested translation values
export const getTranslation = (translations, language, path) => {
  const keys = path.split('.');
  let value = translations[language];
  
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      // Fallback to Spanish if translation is missing
      value = translations.es;
      for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
          value = value[k];
        } else {
          return path; // Return the path if translation is not found
        }
      }
      break;
    }
  }
  
  return value;
};